<template>
  <div v-if="options.length !== 0" class="relative">
    <SingleSelect
      v-model="model"
      :options="options"
      :label="label"
      :required="false"
      :pills="true"
    />
  </div>
</template>

<script setup lang="ts">
import { getTranslatedProperty } from '@shopware/helpers'

export type Filter = {
  label: string
  code: string
  name: string
  apiAlias: string
  entities: any[]
}

const props = defineProps<{
  filter: Filter
}>()

const { t } = useI18n()
const model = defineModel<any>()

const label = computed(() => {
  if (props.filter.code === 'manufacturer') {
    return t('entity.manufacturer.label')
  }
  return getTranslatedProperty(props.filter, 'label')
})

const options = computed(() =>
  props.filter.entities.map((entity) => {
    return {
      value: entity.id,
      label: getTranslatedProperty(entity, 'name'),
    }
  })
)
</script>
